import { defineComponent as _defineComponent } from 'vue'
import OptimizerIconV2 from '@sh/components/Utils/OptimizerIconV2.ts.vue';
import { IconsV2 } from '@sh/types/General';

export interface LoginCardProps {
  icon: IconsV2;
  title: string;
  description: string;
  features?: string[];
  button: {
    text: string;
    href: string;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginCard.ts',
  props: {
    icon: null,
    title: null,
    description: null,
    features: null,
    button: null
  },
  setup(__props: any) {



return { __sfc: true,OptimizerIconV2 }
}

})